// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import objectAssignPolyfill from 'es6-object-assign/auto'
import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'
import App from './App'
import router from './router'
import langCo from 'vue-lang'
import Vue2TouchEvents from 'vue2-touch-events'
import VueScrollTo from 'vue-scrollto'

/** Custom code **/
import pUtil from './plugins/vue-util'
import pStore from './plugins/vue-store'

/** Language files **/
import langSv from './assets/text/sv.json'
// import langFi from './assets/text/fi.json'
// import langDk from './assets/text/dk.json'
// import langNo from './assets/text/no.json'
// import langEn from './assets/text/en.json'

import Context from './assets/data/context.json'

const locales = {
  'sv': langSv
  // 'fi': langFi
  // 'dk': langDk
  // 'no': langNo
  // 'en': langEn
}

/** Communications Bus (Change this to vuex if needed!!!) **/
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false
Vue.use(langCo, {lang: 'sv', locales: locales})
Vue.use(objectAssignPolyfill)
Vue.use(pUtil)
Vue.use(pStore)
Vue.use(vueVimeoPlayer)
Vue.use(Vue2TouchEvents)

let nav = ((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1))
if (nav === undefined) {
  nav = true
} else {
  nav = !nav
}

Vue.use(VueScrollTo, {
  container: '#scrollContainer',
  duration: 500,
  easing: 'ease-out',
  offset: 0,
  // cancelable: false, // If false, there can be some flickering (on desktop devices) sometimes
  cancelable: nav,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  data () {
    return {
      context: Context
    }
  },
  beforeMount () {
    this.util.init()
  },
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js